import { observer } from 'mobx-react';
import marketplaceStore from '../../../store/marketplaceStore';
import Switcher from '~/view/components/Controls/Switcher/Switcer';
import Text, { TEXT } from '~/view/components/Text/Text';
import TooltipIcon from '~/view/components/TooltipIcon/TooltipIcon';
import { TOOLTIP_DURATION, TOOLTIP_POSITION } from '~/view/components/Controls/CustomTooltip/CustomTooltip';
import { localeStore } from '~/mobx/localesStore';
import { TBooleanInNumber } from '~/types/main';
import { booleanToNumber } from '~/utils/helpers';

const Franchise = (): JSX.Element | null => {
  if (marketplaceStore.selectedFeature?.status !== true) {
    return null;
  }

  const handleStatusChange = (status: TBooleanInNumber): void => {
    marketplaceStore.changeSelectedFeatureData({ franchise_unintegrated_branches: Boolean(status) });
  };

  return (
    <div className="d-flex align-items-center mt-6">
      <Switcher status={booleanToNumber(marketplaceStore.selectedFeature?.franchise_unintegrated_branches ?? false)} onChange={handleStatusChange} />
      <Text type={TEXT.SWITCHER_LABEL} text={localeStore.t('unintegrate_branches')} />
      <TooltipIcon
        wrapperClassName="ml-1 mr-1"
        message={localeStore.t('unintegrate_branches_infotip')}
        duration={TOOLTIP_DURATION.EXTRA_LARGE}
        position={TOOLTIP_POSITION.PORTAL}
        maxWidth={280}
        gapTop={10}
        messageClassName="branches-unintegrate___toggle-tooltip"
      />
    </div>
  );
};

export default observer(Franchise);
